import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { colors } from '@spaceshipapp/cambridge';

const variantStyle = {
  default: {
    background: colors.border,
  },
  warning: {
    background: colors.highlightPrimary,
  },
};

export const Wrapper = styled.div<{ variant: 'default' | 'warning' }>`
  padding: 0.75rem 1.5rem;
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  background: ${(props) => variantStyle[props.variant].background};

  svg {
    overflow: visible;
  }

  & > *:not(:last-child) {
    margin-right: 0.5rem;
  }
`;

export const styledText = css`
  text-align: left;
`;
